module.exports = __webpack_public_path__ + "img/375-1da65b.png";